import { clsx } from 'clsx';
import { DeletePopup } from 'src/components/DeletePopup/DeletePopup';
import { DeleteIconSimple } from 'src/assets/icons/deleteIconSimple';
import { Switch } from 'src/components/ui/switch';
import { useParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'src/services';
import { INTEGRATION_SETTING_POPUP_ID } from 'src/shared/constants';
import React, { useEffect, useState } from 'react';
import { setSelectedIntegration } from 'src/store/slices/integrationSlice';
import { useDispatch } from 'react-redux';
import { EditIntegrationPopup } from 'src/components/Integrations/EditIntegrationPopup/EditIntegrationPopup';
import { Button } from 'src/components/ui/button';
import { EditIconSettings } from 'src/assets/icons/editIconsSettings';
import { Separator } from 'src/components/ui/separator';
import { CrossCircleIcon } from 'src/assets/icons/crossCircleIcon';
import { IntegrationsModal } from 'src/pages/ControlDeskPage/IntegrationStatusSection/IntegrationsModal/IntegrationsModal';
import { DialogTrigger } from 'src/components/ui/dialog';
import { SettingsPopoverButton } from 'src/components/SettingsPopoverButton/SettingsPopoverButton';

export const CurrentFreshchatIntegration = ({
  integrationTypeConfig,
  integration,
  deleteIntegrationHandler,
  disabledByPermision = false,
}) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const { data: currentProject } = useGetProjectByIdQuery({ id: id }) as any;
  const openIntegrationId = localStorage.getItem(INTEGRATION_SETTING_POPUP_ID);
  const isOpen = openIntegrationId && integration.id === +openIntegrationId;

  useEffect(() => {
    if (currentProject) {
      setDisabled(!currentProject?.is_active);
    }
  }, [currentProject]);

  useEffect(() => {
    dispatch(setSelectedIntegration({ ...integrationTypeConfig, ...integration }));
    return () => {
      dispatch(setSelectedIntegration(null));
    };
  }, []);

  return (
    <div className={clsx('transition flex justify-between items-center')}>
      <div className="flex items-center gap-2.5">
        <div className="w-fit">
          {integrationTypeConfig.icon && (
            <img className="h-[30px] w-[30px]" src={integrationTypeConfig.icon} />
          )}
        </div>
        <div className="flex items-center gap-2.5">
          <p className="font-medium font-jamjuree text-sm text-ebony opacity-80">
            {integrationTypeConfig.friendlyName || ''}
          </p>
        </div>
      </div>
      <div>
        <SettingsPopoverButton
          disabledByPermision={disabledByPermision}
          content={
            <>
              <div className="flex flex-col items-center sm:justify-end justify-between">
                <div className="flex flex-col w-full">
                  <EditIntegrationPopup
                    isOpen={isOpen}
                    integration={integration}
                    trigger={
                      <Button variant="ghost" className="w-full justify-start !rounded-none">
                        <div className="flex items-center gap-2.5">
                          <EditIconSettings />
                          <p className="opacity-80 font-medium text-sm">Settings</p>
                        </div>
                      </Button>
                    }
                  />
                  <Separator className={'bg-[#E3E6E8]'} />
                </div>
                <div className="flex flex-col w-full">
                  <Button disabled variant="ghost" className="w-full justify-start !rounded-none">
                    <div className="flex items-center gap-2.5">
                      <CrossCircleIcon />
                      <p className="opacity-80 font-medium text-sm">Deactivate</p>
                    </div>
                  </Button>
                  <Separator className={'bg-[#E3E6E8]'} />
                </div>
                <div className="flex flex-col w-full">
                  <DeletePopup
                    disabled={disabled}
                    deleteHandler={() => deleteIntegrationHandler(integration.id)}
                    description={`Are you sure you want to delete the integration?`}
                    triggerIcon={
                      <Button variant="ghost" className="w-full justify-start !rounded-none">
                        <div className="flex items-center gap-2.5">
                          <div className="[&_svg>path]:fill-error">
                            <DeleteIconSimple />
                          </div>
                          <p className="opacity-80 font-medium text-sm text-error">Delete</p>
                        </div>
                      </Button>
                    }
                  />
                </div>
              </div>
            </>
          }
        />
      </div>
    </div>
  );
};
